import {Component, Inject, Input, Output, Pipe, PipeTransform, ViewChild, HostListener, EventEmitter, OnDestroy} from '@angular/core';

import {ApiService} from '../shared/api.service';

@Component({
    selector: 'slug-component',
    templateUrl: 'slug.component.html'
})
export class SlugComponent {
    available = false;
    checked = false;
    desiredSlug = '';
    error = '';
    loading = false;

    private _allowEmpty = false;
    private _blog_id = false;
    private _canEdit = false;
    private _post_id = false;
    private _slug = '';

    @Input('allowEmpty')
    set allowEmpty(allowEmpty) {
        this._allowEmpty = allowEmpty;
    }
    get allowEmpty() {
        return this._allowEmpty;
    }
    @Input('blog_id')
    set blog_id(blog_id) {
        this._blog_id = blog_id;
    }
    get blog_id() {
        return this._blog_id;
    }
    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('post_id')
    set post_id(post_id) {
        this._post_id = post_id;
    }
    get post_id() {
        return this._post_id;
    }
    @Input('slug')
    set slug(slug) {
        this._slug = slug;
    }
    get slug() {
        return this._slug;
    }

    @Output() slugChange = new EventEmitter();
    @Output() propChange = new EventEmitter();
    
    constructor(private api: ApiService) {}
    ngAfterViewInit() {
        this.desiredSlug = this.slug;
        this.checkSlugAvailability();
    }
    cleanSlug(slug) {
        return this.desiredSlug
            .replace(/(\s+)/g, '-')
            .replace(/(-{2,})/g, '-')
            .replace(/([^a-zA-Z0-9-])/g, '')            
            .toLowerCase();
    }
    checkSlugAvailability() {
        this.available = false;
        this.checked = false;
        if( this.allowEmpty && this.desiredSlug == '' ) {
            this.available = true;
            this.checked = true;
            this.propChange.emit(this);
            return;
        }
        this.error = '';
        this.desiredSlug = this.cleanSlug(this.desiredSlug);
        this.loading = true;
        this.propChange.emit(this);
        this.api.doAction('post', 'sites', {
            action: 'check_slug',
            blog_id: this.blog_id,
            slug: this.desiredSlug,
            post_id: this.post_id
        }).subscribe(
            data => {
                this.loading = false;
                this.checked = true;
                this.available = data.available;
                this.propChange.emit(this);
                if( data.available ) {
                    this.slug = this.desiredSlug;
                    this.slugChange.emit(this.slug);
                }
            }
        );
    }

}